import React from "react";
import { Chip } from "@material-ui/core";
import CallToActionIcon from "@material-ui/icons/ErrorOutline";
import ProposeStatementIcon from "@material-ui/icons/HelpOutline";
import { useTranslation } from "react-i18next";
import Tooltip from "../shared/Tooltip";
import { commentTypes } from "../../firebase/comments";

interface Props {
  commentType: string;
}

export default function CommentType({ commentType }: Props) {
  const { t } = useTranslation();

  if (commentType === commentTypes.COMMENT) return null;

  const tooltip = t("comment." + commentType + "tooltip");

  return (
    <Tooltip title={tooltip}>
      <Chip
        label={commentType}
        variant="outlined"
        size="small"
        aria-label={tooltip}
        icon={
          commentType === commentTypes.ACTION ? (
            <CallToActionIcon />
          ) : (
            <ProposeStatementIcon />
          )
        }
      />
    </Tooltip>
  );
}
